import * as CategoryType from 'show-page/constants/category-type';
import MoreLinks from 'show-page/components/more-links';
import OnlineExclusives from 'show-page/components/online-exclusives';
import styles from './styles.less';
import { observer } from 'mobx-react';


@observer(['showStore', 'uiStore'])
class ShowFooter extends React.Component {
    static propTypes = {
        onVideoSelect: React.PropTypes.func.isRequired
    };

    render() {
        const className = cx(styles.root, this.props.className);
        return (
            <div className={ className }>
                { this.renderOnlineExclusives() }
                { this.renderMoreLinks() }
            </div>
        );
    }

    renderMoreLinks() {
        if (this.props.showStore.moreLinks.length < 1) {
            return null;
        }
        const { highlightColor, moreLinks, rolloverTextColor, title } = this.props.showStore;
        return (
            <div className={ styles.moreLinksContainer }>
                <MoreLinks
                    className={ styles.moreLinks }
                    highlightColor={ highlightColor }
                    links={ moreLinks }
                    rolloverTextColor={ rolloverTextColor }
                    showTitle={ title }
                />
            </div>
        );
    }

    renderOnlineExclusives() {
        if (this.props.uiStore.selectedCategory !== CategoryType.EPISODES || this.props.showStore.onlineExclusives.length < 1) {
            return null;
        }
        const { highlightColor, onlineExclusives, rolloverTextColor, selectedVideoId } = this.props.showStore;
        const { onVideoSelect } = this.props;
        return (
            <div className={ styles.onlineExclusivesContainer }>
                <OnlineExclusives
                    className={ styles.onlineExclusives }
                    clips={ onlineExclusives }
                    highlightColor={ highlightColor }
                    onVideoSelect={ onVideoSelect }
                    rolloverTextColor={ rolloverTextColor }
                    selectedVideoId={ selectedVideoId }
                />
            </div>
        );
    }
}


export default ShowFooter;



/** WEBPACK FOOTER **
 ** ./src/show-page/containers/show-footer/index.js
 **/